window.CartUtils = window.CartUtils || {};

window.CartUtils.updateCount = async function () {
  const cartItemCountSections = document.querySelectorAll(
    "[data-cart-item-count]",
  );

  if (cartItemCountSections.length > 0) {
    try {
      const url = new URL(window.location);
      url.searchParams.set("section_id", "cart-item-count");

      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          Accept: "text/html",
          "X-Requested-With": "XMLHttpRequest",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const newSection = doc.querySelector("[data-cart-item-count]");

      if (newSection) {
        cartItemCountSections.forEach((section) => {
          section.innerHTML = newSection.innerHTML;
          section.dataset.cartItemCount = newSection.dataset.cartItemCount;
        });
      }
    } catch (error) {
      console.error("Error updating cart section:", error);
      throw error;
    }
  }
};

document.addEventListener("cart:updated", function (event) {
  if (window.CartUtils && window.CartUtils.updateCount) {
    window.CartUtils.updateCount();
  }
});
